import React, { FC } from 'react';

import { Popover, Calendar, SelectorButton } from '@gem/ui-kit';

import { getLanguage } from 'UTILS/getLanguage';

import { useDatePickerPresenter } from './DatePicker.presenter';
import styles from './DatePicker.styles.m.css';

interface IDatePickerProps {
  value: Date;
  label: string;
  onChange(date: Date): void;
}

export const DatePicker: FC<IDatePickerProps> = React.forwardRef<
  HTMLButtonElement,
  IDatePickerProps
>((props, _ref) => {
  const { presenter, anchorRef } = useDatePickerPresenter(props);

  return (
    <>
      <SelectorButton
        label={props.label}
        title={presenter.formatedTitle}
        onClick={presenter.onSwitchPicker}
        isActive={presenter.isPickerOpen}
        setRef={anchorRef}
      />
      <Popover
        isOpened={presenter.isPickerOpen}
        onClose={presenter.onSwitchPicker}
        reference={anchorRef.current}
        placement="bottom-end"
        className={styles.popover}
        isFullWidth
        modifiers={[
          {
            name: 'offset',
            options: { offset: [0, 0] },
          },
        ]}
      >
        <Calendar
          value={presenter.value}
          onChange={presenter.onChange}
          locale={getLanguage()}
          className={styles.calendar}
        />
      </Popover>
    </>
  );
});
